import firebase from 'firebase'
import firestore from 'firebase/firestore'

const DEV_ENV = false

if (DEV_ENV) {
  //DEVELOPMENT
  //ENVIRNOMENT DEACTIVATED
  // var config = {
  //   apiKey: "AIzaSyAS7iG1DSdBwWPREm4eOXvOTN_rxSZ-Ixg",
  //   authDomain: "omentum-test.firebaseapp.com",
  //   databaseURL: "https://omentum-test.firebaseio.com",
  //   projectId: "omentum-test",
  //   storageBucket: "omentum-test.appspot.com",
  //   messagingSenderId: "404220981123",
  //   appId: "1:404220981123:web:665f5323779534df4e50b6",
  //   measurementId: "G-RR8KHSYCR3"
  // };
}
else {
  //PRODUCTION
  var config = {
     apiKey: "AIzaSyAdreth7jAys-YdcYW4fIpNp_EP-b1SMzw",
     authDomain: "omentum-prod.firebaseapp.com",
     databaseURL: "https://omentum-prod.firebaseio.com",
     projectId: "omentum-prod",
     storageBucket: "omentum-prod.appspot.com",
     messagingSenderId: "430432189407",
     appId: "1:430432189407:web:1cf71bad93dc386b0b626a",
     measurementId: "G-K2E082Q0EQ"
  };
}

const firebaseApp = firebase.initializeApp(config);
const analytics = firebase.analytics();
console.log(config)
export default {
  devStatus: DEV_ENV,
  target: config.authDomain,
  fb: firebaseApp.firestore(),
  analytics: analytics,
  
}
